import { exists } from "./utils";

export class ProcedureReadingCollection {
    public assetProcedureReadingCompletionLookup: Map<string, boolean> = new Map<string, boolean>();

    constructor() { }

    public populateCollection(rawWorkorders: any): void {
        let readingsCompletedCache: Map<string, boolean> = new Map<string, boolean>();

        for (let i = 0; i < rawWorkorders.length; i++) {
            if (!exists(rawWorkorders[i].assetCount) || rawWorkorders[i].assetCount <= 1) {
                continue;
            }

            for (let j = 0; j < rawWorkorders[i].procedures.length; j++) {
                for (let k = 0; k < rawWorkorders[i].procedures[j].readings.length; k++) {
                    const assetId: string = rawWorkorders[i].procedures[j].readings[k].assetId;
                    if (!exists(assetId)) {
                        continue;
                    }

                    const workOrderAssetId: string = rawWorkorders[i].assets.find((asset: { id: string; }) => asset.id === assetId).workOrderAssetId;
                    const readingHasValue: boolean = exists(rawWorkorders[i].procedures[j].readings[k].value);

                    if (readingsCompletedCache.get(workOrderAssetId) === undefined) {
                        readingsCompletedCache.set(workOrderAssetId, readingHasValue);
                        continue;
                    }

                    let procedureReadingsCompleted = readingsCompletedCache.get(workOrderAssetId) && readingHasValue;
                    readingsCompletedCache.set(workOrderAssetId, procedureReadingsCompleted);
                }
            }
        }
      
        readingsCompletedCache.forEach((allReadingsAnswered: boolean, workOrderAssetId: string) => {
            this.assetProcedureReadingCompletionLookup.set(workOrderAssetId, allReadingsAnswered);
        });
    }

    public toJSON(): any {
        return JSON.parse(JSON.stringify(Array.from(this.assetProcedureReadingCompletionLookup.entries())));
    }
}